import clsx from "clsx";
import translate from "../../locales";
import { ShardCard } from "./shard-card";

export function SourceMaterialCard() {
  return (
    <div className={clsx("source-material-card")}>
      <div className={clsx("intro-card")}>
        <svg
          className={clsx("icon")}
          viewBox="0 0 72 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.6781 56.2746C22.5537 55.2664 24.6411 54.7166 26.7699 54.6699C28.8988 54.7166 30.9863 55.2664 32.8617 56.2746L34.729 57.2118C35.5289 57.6121 36.4709 57.6121 37.2708 57.2118L39.1381 56.2746C41.0136 55.2664 43.1011 54.7166 45.2299 54.6699C47.3587 54.7166 49.4462 55.2664 51.3217 56.2746C52.9442 57.0861 54.733 57.509 56.5473 57.5099H57.2998V28.7762L53.8635 27.0581C51.6173 25.8921 49.1686 25.1666 46.6499 24.9209V24.14C46.6499 21.3155 45.5278 18.6065 43.5305 16.6093C41.5334 14.6119 38.8244 13.4898 35.9998 13.4898C33.1751 13.4898 30.4663 14.6119 28.469 16.6093C26.4717 18.6064 25.3496 21.3153 25.3496 24.14V24.9209C22.8313 25.1645 20.3826 25.8875 18.136 27.0509L14.6997 28.7762V57.5099H15.4522C17.2665 57.509 19.0554 57.0861 20.6778 56.2746H20.6781ZM53.0399 31.4104V52.3767C50.6243 51.1245 47.9504 50.4512 45.2299 50.4101C42.7736 50.4392 40.3522 50.996 38.1299 52.0432V31.0556L38.5062 30.871V30.8712C40.5775 29.7628 42.8813 29.1593 45.2299 29.1103C47.5781 29.1572 49.8817 29.7581 51.9536 30.864L53.0399 31.4104ZM35.9999 17.75C37.6948 17.75 39.32 18.4232 40.5183 19.6216C41.7167 20.82 42.3899 22.4452 42.3899 24.14V25.0984C40.373 25.4594 38.4205 26.1175 36.5962 27.0509L35.9999 27.3491L35.4037 27.0509C33.5794 26.1175 31.6269 25.4595 29.6099 25.0984V24.14C29.6099 22.4452 30.2832 20.82 31.4816 19.6216C32.6799 18.4232 34.3052 17.75 35.9999 17.75ZM18.9599 31.4104L20.0462 30.8707V30.871C22.1175 29.7625 24.4213 29.159 26.7699 29.11C29.1181 29.1569 31.4216 29.7578 33.4936 30.8638L33.8699 31.0485V52.0432C31.6476 50.996 29.2262 50.4392 26.7699 50.41C24.0494 50.4512 21.3755 51.1244 18.9598 52.3766L18.9599 31.4104Z"
            fill="#002B6C"
          />
        </svg>

        <div className={clsx("text")}>
          <p className={clsx("subtitle")}>
            {translate("info-sources.source-material.subtitle")}
          </p>
          <p className={clsx("description")}>
            {translate("info-sources.source-material.description")}
          </p>
        </div>
        <div className={clsx("spacer")} />
        <a
          className={clsx("button", "button--outline", "sources")}
          target="_blank"
          href={translate("info-sources.source-material.url")}
          rel="noreferrer"
        >
          {translate("info-sources.source-material.button")}
        </a>
      </div>
      <ShardCard />
    </div>
  );
}
